import { useEffect } from "react";
import { SITE } from "@/data/site";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href, extra = {}) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
  Object.entries(extra).forEach(([k, v]) => el.setAttribute(k, v));
}

export default function SeoHead({
  title,
  description,
  path = "/",
  image,
  keywords,
  type = "website",
  noindex = false,
}) {
  const url = `${SITE.url}${path}`;
  const ogImage = image || `${SITE.url}/og-default.jpg`;

  useEffect(() => {
    document.documentElement.lang = "sr";
    document.title = title;
    setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    setMeta("name", "author", SITE.name);
    setMeta("name", "geo.region", "RS-00");
    setMeta("name", "geo.placename", "Beograd");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:image:alt", description.slice(0, 120));
    setMeta("property", "og:locale", "sr_RS");
    setMeta("property", "og:site_name", SITE.name);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage);
    setLink("canonical", url);
    setLink("alternate", url, { hreflang: "sr-RS" });
  }, [title, description, url, ogImage, keywords, type, noindex]);

  return null;
}
